export default __webpack_public_path__ + "static/notserk_twitchbanner-0b4648194e5ad7ce244d5e37c9e75c0d.png";